import { useGetLineItemsQuery } from "@portal/queries/invoice-query";
import { useMemo, useState } from "react";
import { Select } from "../Select/AntSelect";
import { TagRendererParams } from "../Select/type";
import { SkeletonInput } from "../Skeleton/AntSkeleton";
import { StyledTag } from "../Tag/style";

interface InvoiceLineItemsProps {
  selectedInvoices: string[];
  title?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const t = {
  title: "Choose Line items of ",
  placeholder: "Add Line Item",
};
function InvoiceLineItems(props: InvoiceLineItemsProps) {
  const { selectedInvoices, value: defaultValues, onChange } = props;
  const [value, setValues] = useState<string[] | undefined>(defaultValues);

  const { data, isLoading } = useGetLineItemsQuery(selectedInvoices);

  function getOptions() {
    if (!data) return [];
    return data.list.map((item, index) => {
      return { label: `${index + 1} - ${item.product_name}`, value: item.id };
    });
  }

  const options = useMemo(getOptions, [data]);

  function customTagRender(props: TagRendererParams<string[]>[number]) {
    const { label, onClose } = props;

    return (
      <StyledTag onClose={onClose} closable design="no-bg">
        {label}
      </StyledTag>
    );
  }

  return (
    <>
      {isLoading && !data ? (
        <SkeletonInput />
      ) : (
        <Select<string[]>
          placeholder={t.placeholder}
          options={options}
          value={value}
          tagRender={customTagRender}
          optionLabelProp="label"
          optionFilterProp="label"
          showSearch
          mode="multiple"
          onChange={(value) => {
            setValues(value);
            onChange?.(value);
          }}
          getPopupContainer={(node) => {
            return node.parentNode as HTMLElement;
          }}
          maxTagCount="responsive"
        />
      )}
    </>
  );
}

export { InvoiceLineItems };
